import { useCallback, useContext } from 'react';

import {
  ChainlitContext,
  IStarter,
  useChatData
} from '@chainlit/react-client';

import { Button } from '@/components/ui/button';

import { prefillComposer } from './MessageComposer';

interface StarterProps {
  starter: IStarter;
}

export default function Starter({ starter }: StarterProps) {
  const apiClient = useContext(ChainlitContext);
  const { loading, connected } = useChatData();

  const disabled = loading || !connected;

  // Type it into the composer; do not send. The user gets to read the question,
  // edit it, or ignore it -- which is what a suggestion is. Sending on click
  // meant a mis-click spent a question the user had not finished reading.
  const onSubmit = useCallback(() => {
    prefillComposer(starter.message);
  }, [starter]);

  return (
    <Button
      id={`starter-${starter.label.trim().toLowerCase().replaceAll(' ', '-')}`}
      variant="outline"
      className="w-fit justify-start rounded-3xl"
      disabled={disabled}
      onClick={onSubmit}
    >
      <div className="flex gap-2">
        {starter.icon ? (
          <img
            className="h-5 w-5 rounded-md"
            src={
              starter.icon?.startsWith('/public')
                ? apiClient.buildEndpoint(starter.icon)
                : starter.icon
            }
            alt={starter.label}
          />
        ) : null}
        <p className="text-sm text-muted-foreground truncate">
          {starter.label}
        </p>
      </div>
    </Button>
  );
}
